import { useMemo, useState } from "react";
import { applyTextFilters, SearchText, tokeniseSearchText } from "./text-filters";

export type SetSearchText = (searchText?: SearchText) => void;
export type ApplyTextFilter = <T>(items: T[], getText: (item: T) => string) => T[];

export function useTextFilter<T>(items: T[], getText: (item: T) => string): [T[], SetSearchText] {
  const [searchText, setSearchText] = useState<SearchText>();
  return useMemo(() => {
    const filters = tokeniseSearchText(searchText);
    return [applyTextFilters(filters, items, getText), setSearchText];
  }, [items, getText, searchText, setSearchText]);
}
